import { Currency } from '@/api/types/public';
import { env } from '@/utils/env';

export interface CommonCurrencyInfo {
  source: 'URL' | 'Cookie' | 'IP' | 'Env' | 'Def';
  currency: Currency;
}

/**
 * 从 currencyList 中找到默认货币（IP 检测）
 */
export function getDefaultCurrencyFromList(currencyList: Currency[]): Currency | null {
  // TODO：风险问题，如果线上走内部接口，后端是没办法拿到客户端的IP的
  const defaultCurrency = currencyList.find((item) => +item.is_default === 1);
  return defaultCurrency || null;
}

/**
 * 获取环境变量默认货币
 */
export function getEnvDefaultCurrency(currencyList: Currency[]): Currency | null {
  const defaultCurrencyName = env.NEXT_PUBLIC_DEFAULT_CURRENCY || 'USD';
  const currency = currencyList.find((item) => item.name === defaultCurrencyName);

  if (currency) {
    return currency;
  }

  const firstCurrency = currencyList[0];
  if (firstCurrency) {
    return firstCurrency;
  }

  return null;
}

/**
 * 获取兜底的默认货币
 */
export function getDefaultGuaranteedCurrency(): CommonCurrencyInfo {
  return {
    source: 'Def',
    currency: {
      name: 'USD',
      full_symbol: '$',
      symbol: '$',
      exchange_rate: '1.000000',
      symbol_prefix: '$',
      symbol_suffix: '',
    },
  };
}
